var map = {
	"./arrow-right.png": "e9c1",
	"./arrow.png": "5a8f",
	"./back.png": "1faf",
	"./delete.png": "fd6f",
	"./logo.png": "4ffd",
	"./menu.png": "7738",
	"./refresh.png": "dce7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";